import { render, staticRenderFns } from "./UserTrendTooltip.vue?vue&type=template&id=2acacfba&scoped=true"
import script from "./UserTrendTooltip.vue?vue&type=script&lang=ts"
export * from "./UserTrendTooltip.vue?vue&type=script&lang=ts"
import style0 from "./UserTrendTooltip.vue?vue&type=style&index=0&id=2acacfba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acacfba",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/user-trend/scatter/user-trend-tooltip.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fuser-trend%2Fscatter%2FUserTrendTooltip.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports